import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { Doughnut } from "react-chartjs-2";
import { connect } from "react-redux";
import FlowUtils from "services/flow/utils";
import ParkkiTheme from "themes/ParkkiTheme";

const styles = {
  container: {
    width: "80%",
  },
  contentRowContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    marginTop: ParkkiTheme.spacings.base,
    color: ParkkiTheme.colors.darkGrey,
    fontSize: ParkkiTheme.fontSizes.xsmall,
  },
  percentageLabel: {
    fontWeight: "600",
    fontSize: ParkkiTheme.fontSizes.small,
  },
};

class PointDoughnutLayout extends React.Component {
  getFormattedPercentage = (percentage = 0) => {
    return percentage;
  };

  getDoughnutData = () => {
    const { intl, stats, inOutDistributionByPercentage } = this.props;
    return stats.reduce((result, currentStat) => {
      return {
        ...result,
        labels: [
          ...(result.labels ?? []),
          intl.messages[
            `flowScene.flowType.${currentStat.type?.toLowerCase() ?? ""}`
          ].replace(/./, (x) => x.toUpperCase()),
        ],
        datasets: [
          {
            ...(result.datasets?.[0] ?? {}),
            data: [
              ...(result.datasets?.[0]?.data ?? []),
              inOutDistributionByPercentage
                ? currentStat.percentage ?? 0
                : currentStat.value ?? 0,
            ],
            backgroundColor: [
              ...(result.datasets?.[0].backgroundColor ?? []),
              FlowUtils.getColorFromType(currentStat.type),
            ],
            borderWidth: 1,
          },
        ],
      };
    }, {});
  };

  getDoughnutOptions = () => {
    const { intl, stats, inOutDistributionByPercentage } = this.props;

    return {
      rotation: 1 * Math.PI,
      circumference: 1 * Math.PI,
      legend: {
        display: false,
      },
      tooltips: {
        callbacks: {
          label: (tooltipItem, data) => {
            const dataset = data.datasets[0];

            const tooltipItemIndex = tooltipItem.index;

            const value = dataset.data[tooltipItemIndex];

            const type = stats?.[tooltipItemIndex].type;

            const formattedLabel = intl.formatMessage(
              {
                id: `flowScene.flowType.${(type ?? "").toLowerCase()}`,
              },
              { count: inOutDistributionByPercentage ? 2 : value ?? 2 }
            );

            return ` ${formattedLabel[0].toUpperCase()}${formattedLabel.slice(
              1
            )} : ${value || 0} ${inOutDistributionByPercentage ? "%" : ""}`;
          },
          afterLabel: (tooltipItem, data) => "",
        },
      },
    };
  };

  renderContentRow = () => {
    const { intl, stats, inOutDistributionByPercentage } = this.props;

    return (
      <div style={styles.contentRowContainer}>
        <div>
          {stats
            .filter((item) => item?.percentage > 0)
            .map((item, key) => {
              return (
                <div key={`${item.percentage}-${key}`}>
                  <span
                    style={{
                      ...styles.percentageLabel,
                      color: FlowUtils.getColorFromType(item?.type),
                    }}
                  >
                    {inOutDistributionByPercentage
                      ? `${parseFloat(
                          this.getFormattedPercentage(item.percentage),
                          10
                        )} % `
                      : `${item?.value} `}
                  </span>
                  {inOutDistributionByPercentage
                    ? intl.formatMessage(
                        {
                          id: "flowScene.inOutDistribution.expandableStats.content",
                        },
                        {
                          type: intl.formatMessage(
                            {
                              id: `flowScene.flowType.${(
                                item?.type ?? ""
                              ).toLowerCase()}`,
                            },
                            { count: 2 }
                          ),
                        }
                      )
                    : intl.formatMessage(
                        {
                          id: `flowScene.flowType.${(
                            item?.type ?? ""
                          ).toLowerCase()}`,
                        },
                        { count: item?.value ?? 2 }
                      )}
                </div>
              );
            })}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div style={styles.container}>
        <Doughnut
          data={this.getDoughnutData()}
          options={this.getDoughnutOptions()}
          onElementsClick={() => {}}
        />
        {this.renderContentRow()}
      </div>
    );
  }
}

PointDoughnutLayout.defaultProps = {
  stats: [],
};

PointDoughnutLayout.propTypes = {
  stats: PropTypes.arrayOf(PropTypes.shape({})),
};

const mapStateToProps = (state) => ({
  inOutDistributionByPercentage:
    state?.Flow.filters.inOutDistributionByPercentage,
});

export default connect(mapStateToProps)(injectIntl(PointDoughnutLayout));
